import { queryOptions } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';

import { ListResultV2, RequestParamsV2 } from '@xemplo/gp-types';
import { createNoResultList, ListBuilder } from '@xemplo/stateful-list-core';
import { apiUrlBuilder } from '@xemplo/url-helper';

import { GP_TAG_ENDPOINTS } from './gp-tags-constants';
import { Tag } from './gp-tags-types';

/**
 * Transform tag list API response to stateful list format
 */
function transformToStatefulList(tags: Tag[]) {
  if (tags.length === 0) {
    return createNoResultList({ label: 'No Tags Found' });
  }

  return ListBuilder.create()
    .addGroup((group) => {
      tags.forEach((tag) => group.addItem(tag.id, tag.value));
      return group;
    })
    .build();
}

/**
 * Tag query factory
 */
export const tagQueries = {
  all: ['tags'] as const,
  lists: () => [...tagQueries.all, 'list'] as const,
  list: (
    params: RequestParamsV2,
    client: AxiosInstance,
    applicationApiUrl: string | undefined,
  ) => {
    const url = apiUrlBuilder(GP_TAG_ENDPOINTS.tags, applicationApiUrl, params);
    return queryOptions({
      queryKey: [...tagQueries.lists(), url] as const,
      queryFn: ({ signal }) =>
        client.get<ListResultV2<Tag>>(url, { signal }).then((resp) => resp.data),
      // select: (data) => transformToStatefulList(data.result.rows),
    });
  },
};
